import {useQuery} from 'react-query';
import {getPostWantedDetail} from 'services/wantedPost/getDetailWantedPost';
interface GetWantedPostParams {
  guid: string;
}
const useGetWantedPost = (params: GetWantedPostParams) => {
  const {data: wantedpostData, isLoading :isLoadingWantedpost} = useQuery(
    ['wanted-post-detail', params?.guid],
    getPostWantedDetail,
  );
  return {wantedpostData, isLoadingWantedpost};
};

export default useGetWantedPost;
